import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const getOrder = async (token) => {
  const response = await axios({
    method: "get",
    url: baseurl + `/getOrder`,
    headers: {
      token: token,
    },
  });
  return response.data.data;
};
